import RaceTransactionTable from './RaceTransactionTable';

export default RaceTransactionTable;
